export default {
  debug: false,
  baiduMapsApiKey: '3Ckyh53lLbFUdc0qivXymFfkydDExUy3',
}
